module.exports = new __parcel__URL__("airmail.082a6059.webp").toString();